import { useContext, useEffect } from 'react'
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom'

type Tx = {
  location: { pathname: string }
  retry: () => void
}

export function useBlocker(blocker: (tx: Tx) => void, when: boolean) {
  const { navigator }: any = useContext(NavigationContext)

  useEffect(() => {
    if (!when) return

    // Keep original methods
    const originalPush = navigator.push.bind(navigator)
    const originalReplace = navigator.replace.bind(navigator)

    function wrap(method: (...args: any[]) => void) {
      return (...args: any[]) => {
        const path = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].pathname) || ''

        blocker({
          location: { pathname: path },
          retry() {
            navigator.push = originalPush
            navigator.replace = originalReplace
            method(...args) // retry the original call
          },
        })
      }
    }

    navigator.push = wrap(originalPush)
    navigator.replace = wrap(originalReplace)

    return () => {
      navigator.push = originalPush
      navigator.replace = originalReplace
    }
  }, [navigator, blocker, when])
}
